export const SHAKE_CLASS_NAME = 'shake-that'
